module.exports = __webpack_public_path__ + "static/media/mpl-qr-footer-simple.b1e0be00.jpg";